import FlyBalls from './_components/flyball';
import {Menu, ActivityIndicator, NavBar} from 'antd-mobile';
import './MyMenu.css';
import CONF_LAN from './config/LAN.js';
import LAN_MENU from './config/LAN_MENU';

const menus = LAN_MENU[window.CUR_LAN];
let flyBalls = undefined;

class MyMenu extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            initData: (this.props.menus ? this.props.menus : menus),
            show: false,
        };
    }

    componentDidMount() {
        if (!flyBalls) {
            flyBalls = new FlyBalls(this.refs['menu-outer'], 'menu-canvas');
            this.refs['menu-outer'].style.position = 'static';
            flyBalls.Run();
        }
        //window.addEventListener('orientationchange,resize', function () {
          //  that.forceUpdate();
        //});
    }

    onChange = (value) => {
        let label = '', href = '';
        this.state.initData.forEach((dataItem) => {
            if (dataItem.value === value[0]) {
                label = dataItem.label;
                if (dataItem.children && value[1]) {
                    dataItem.children.forEach((cItem) => {
                        if (cItem.value === value[1]) {
                            label += ` ${cItem.label}`;
                            href = cItem.href;
                        }
                    });
                }
            }
        });
        console.log(label);
        if (href) {
            //window.open(href)
            window.location.href = (href);
        }
    }
    handleClick = (e) => {
        e.preventDefault(); // Fix event propagation on Android
        $('html,body').scrollTop(0);
        this.setState({
            show: !this.state.show,
        }, () => {
            if(document.getElementById('menu-mask')){
                document.getElementById('menu-mask').removeEventListener("touchmove", this.preventMaskTouch);
                document.getElementById('menu-mask').addEventListener("touchmove", this.preventMaskTouch, {
                    passive: false //  禁止 passive 效果
                })
            }
            document.body.removeEventListener("touchmove", this.preventMaskTouch);
            document.body.addEventListener('touchmove', this.preventMaskTouch, {
                passive: false //  禁止 passive 效果
            })
        });

        if (!this.state.show) {
            $('body').css('overflow-y', 'hidden');
        }
        else {
            $('body').css('overflow-y', '');
        }
    }
    preventMaskTouch = (e) => {
        e.preventDefault();
    }
    onMaskClick = () => {
        this.setState({
            show: false,
        });
        $('body').css('overflow-y', '');
        document.body.removeEventListener("touchmove", this.preventMaskTouch);
    }
    onMaskTouchMove = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }
    onClickChangeLan = () => {
        window.location.href = (this.props.cglanto);
    }
    onClickToIndex = () => {
        if (this.props.siteindex) {
            window.location.href = (this.props.siteindex);
        }
    }

    render() {
        const {initData, show} = this.state;
        const {title, curmenuvalue} = this.props;
        const menuEl = (
            <Menu
                className="foo-menu"
                data={initData}
                value={curmenuvalue ? curmenuvalue : []}
                onChange={this.onChange}
                height={200}
            />
        );
        const loadingEl = (
            <div style={{
                width: '100%',
                height: document.documentElement.clientHeight * 0.6,
                display: 'flex',
                justifyContent: 'center'
            }}>
                <ActivityIndicator size="large"/>
            </div>
        );
        return (
            <div ref={'menu-outer'} className={show ? 'menu-active' : ''}>
                <div>
                    <NavBar
                        leftContent=""
                        mode="dark"
                        icon={<img src={BASE_MOBILE_ROOT + "img/common/menu_more.png"} className="am-icon am-icon-md"
                                   alt=""/>}
                        onLeftClick={this.handleClick}
                        className="top-nav-bar"
                        rightContent={<img style={{'display': (this.props.hasChangeLan === false ? 'none' : '')}}
                                           className={'change-lan-img'} onClick={this.onClickChangeLan}
                                           src={CONF_LAN[CUR_LAN]['img_real_dir'] + 'head_lan.png'}/>}
                    >
                        <img onClick={this.onClickToIndex} src={BASE_MOBILE_ROOT + "img/common/NExT_Studios_LOGO_W_PC_SM_1.png"}
                             className={'logo-img'}></img>
                    </NavBar>
                </div>
                {show ? initData ? menuEl : loadingEl : null}
                {show ? <div id={"menu-mask"} className="menu-mask" onClick={this.onMaskClick}
                             onTouchMove={this.onMaskTouchMove}/> : null}
            </div>
        );
    }
}

export default MyMenu;